module.exports = __webpack_public_path__ + "static/img/colorbg.41836e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/colorbg.png
// module id = H8Dh
// module chunks = 1